(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("basesite_script_bundle", [], factory);
	else if(typeof exports === 'object')
		exports["basesite_script_bundle"] = factory();
	else
		root["basesite_script_bundle"] = factory();
})(this, function() {
return 